import { render, staticRenderFns } from "./PaymentTerms.vue?vue&type=template&id=e6da2d06&scoped=true"
import script from "./PaymentTerms.vue?vue&type=script&lang=js"
export * from "./PaymentTerms.vue?vue&type=script&lang=js"
import style0 from "./PaymentTerms.vue?vue&type=style&index=0&id=e6da2d06&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6da2d06",
  null
  
)

export default component.exports